import type { UserProfile } from '@/models/firestore'

type HouseholdMembershipProfile = Pick<UserProfile, 'households' | 'current_household'>

/**
 * Return the household document IDs that should be loaded for a user.
 *
 * `current_household` is only used for profiles from older invitation flows
 * that do not have a membership array yet. Once the array exists, it is the
 * source of truth so a departed household cannot be reloaded from a stale
 * selection.
 */
export const getHouseholdIdsForQuery = (
  user: HouseholdMembershipProfile | null | undefined
): string[] => {
  const candidateIds: unknown[] = user?.households === undefined
    ? [user.current_household]
    : user.households

  return Array.from(new Set(
    candidateIds.filter(
      (id): id is string => typeof id === 'string' && id.trim().length > 0
    )
  )).slice(0, 30)
}
